import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { groupFavorites, useAnalyticsFavorites } from "../lib/analyticsFavorites";
import { analyticsDestination } from "../lib/analyticsSearch";
import { FavoriteEntryContext } from "./AnalyticsFavorites";
import "./QuickAccess.css";

export default function QuickAccessPanel({ renderAnalytics }) {
  const { favorites, enabled, error } = useAnalyticsFavorites();
  const groups = useMemo(() => groupFavorites(favorites), [favorites]);
  const [group, setGroup] = useState("all");
  const [limit, setLimit] = useState(6);
  const navigate = useNavigate();
  const location = useLocation();
  const validGroup = group === "all" || groups.some(item => item.tab === group) ? group : "all";
  const visibleGroups = validGroup === "all" ? groups : groups.filter(item => item.tab === validGroup);
  const entries = visibleGroups.flatMap(item => item.items);
  const displayedIds = new Set(entries.slice(0, limit).map(entry => entry.id));
  useEffect(() => { setLimit(6); }, [validGroup]);
  return <section className="quick-access-panel" aria-label="Quick Access">
    <div className="quick-access-heading"><div><h2>Quick Access <span>({favorites.length})</span></h2>
      <p>Your starred analytics, grouped by their original tabs.</p></div>
      <small>Saved for your account in this browser.</small></div>
    {error && <div role="alert" className="quick-access-warning">{error}</div>}
    {!enabled ? <div className="quick-access-empty">Quick Access is unavailable for this account.</div> : !favorites.length ?
      <div className="quick-access-empty"><strong>No favorites yet</strong><p>Open any analytics tab and select the ☆ beside a metric, chart or report. It will appear here with its live data.</p>
        <button type="button" onClick={() => navigate("/ceo-command-center")}>Browse Dashboard</button></div> : <>
      <div className="quick-access-groups" role="group" aria-label="Filter favorites by source tab">
        <button type="button" aria-pressed={validGroup === "all"} onClick={() => setGroup("all")}>All ({favorites.length})</button>
        {groups.map(item => <button type="button" key={item.tab} aria-pressed={validGroup === item.tab} onClick={() => setGroup(item.tab)}>{item.label} ({item.items.length})</button>)}
      </div>
      {visibleGroups.map(item => {
        const shown = item.items.filter(entry => displayedIds.has(entry.id));
        if (!shown.length) return null;
        return <section key={item.tab} className="quick-access-group" aria-label={`${item.label} favorites`}>
          <h3>{item.label} <span>({item.items.length})</span></h3>
          {shown.map(entry => <article className="quick-access-item" key={entry.id}>
            <div className="quick-access-source"><span>{entry.tabLabel} · {entry.kind}</span>
              <button type="button" onClick={() => navigate(analyticsDestination(entry, location))}>Open in {entry.tabLabel} ↗</button></div>
            <FavoriteEntryContext.Provider value={entry}>{renderAnalytics(entry)}</FavoriteEntryContext.Provider>
          </article>)}
        </section>;
      })}
      {entries.length > limit && <button type="button" className="quick-access-load-more" onClick={() => setLimit(value => value + 6)}>Show next {Math.min(6, entries.length - limit)} favorites ({entries.length - limit} remaining)</button>}
    </>}
  </section>;
}
